// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Arrow icon.
 * @param {IconProps} props - The IconProps for the ArrowIcon component.
 * @returns {ReactElement} The GraphIcon component.
 */
export const ArrowIcon = (props: IconProps) => {
  const { color = 'currentcolor', ...rest } = props;
  return (
    <Icon height={3.5} viewBox='0 0 8 14' width={2} color={color} {...rest} id='graph'>
      <path
        d='M7.49488 7.41819L2.15042 12.8841C1.89266 13.1477 1.47477 13.1477 1.21704 12.8841L0.593702 12.2466C0.336385 11.9834 0.33589 11.5569 0.592602 11.2931L4.82818 6.94088L0.592602 2.58867C0.33589 2.32489 0.336385 1.89837 0.593702 1.63521L1.21704 0.9977C1.4748 0.734084 1.89269 0.734084 2.15042 0.9977L7.49485 6.4636C7.75261 6.72718 7.75261 7.15457 7.49488 7.41819Z'
        fill='currentColor'
      />
    </Icon>
  );
};
